import React from 'react'
import './descriptionList.scss'

const List = ({ titleIcon, suptitle, title, links }) => {
	return (
		<dl className="descriptionList">
			<dt className="descriptionList_header">
				<div className="descriptionList_titleIcon">{titleIcon}</div>
				<span className="descriptionList_supTitle">{suptitle}</span>
				<h2 className="descriptionList_title">{title}</h2>
			</dt>
			{links.map((item) => (
				<dd className="descriptionList_item" key={item.id}>
					{item.target !== undefined ? (
						<h3>
							<a
								className={`link descriptionList_link`}
								href={item.href}
								target="_blank"
								rel="noopener noreferrer"
							>
								{item.text}
							</a>
						</h3>
					) : (
						<h3>
							<a className={`link descriptionList_link`} href={item.href}>
								{item.text}
							</a>
						</h3>
					)}
				</dd>
			))}
		</dl>
	)
}

export default List
